/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

export function AsideMenuListAdmin({ layoutProps }) {
  const location = useLocation();

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li
          className={`nav-item mb-3 menu-item ${getMenuItemActive(
            "/admin/list-policy"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/list-policy">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Text/Menu.svg")} />
            </span>
            <span className="menu-text">
              <FormattedMessage id="ASIDE_ADMIN_SUB_NAV_POLICY" />
            </span>
          </NavLink>
        </li>
        <li
          className={`nav-item mb-3 menu-item ${getMenuItemActive(
            "/admin/list-signed-policy"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/list-signed-policy">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/stock-home.svg"
                )}
              />
            </span>
            <span className="menu-text">
              <FormattedMessage id="ASIDE_ADMIN_SUB_NAV_POLICY_SUBSCRIPTION" />
            </span>
          </NavLink>
        </li>
        <li
          className={`nav-item mb-3 menu-item d-none ${getMenuItemActive(
            "/admin/add-policy"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/add-policy">
            <span className="menu-text d-none">
              <FormattedMessage id="ASIDE_ADMIN_SUB_NAV_ADD_POLICY_TITLE" />
            </span>
          </NavLink>
        </li>

        <li
          className={`nav-item mb-3 menu-item d-none ${getMenuItemActive(
            "/admin/view-policy/"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/view-policy/">
            <span className="menu-text d-none">
              <FormattedMessage id="ASIDE_ADMIN_SUB_NAV_VIEW_POLICY_TITLE" />
            </span>
          </NavLink>
        </li>

        <li
          className={`nav-item mb-3 menu-item d-none ${getMenuItemActive(
            "/admin/add-communication"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/add-communication">
            <span className="menu-text d-none">
              <FormattedMessage id="ADD_COMMUNICATION_BUTTON" />
            </span>
          </NavLink>
        </li>

        <li
          className={`nav-item mb-3 menu-item d-none ${getMenuItemActive(
            "/admin/view-communication-file/"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/view-communication-file/">
            <span className="menu-text d-none">
              <FormattedMessage id="VIEW_COMMUNICATION_FILE" />
            </span>
          </NavLink>
        </li>
      </ul>
    </>
  );
}
